import { render, staticRenderFns } from "./book_set__form.vue?vue&type=template&id=0d0523d8"
import script from "./book_set__form.vue?vue&type=script&lang=js"
export * from "./book_set__form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports